// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LectureLessonListModuleListModel from '../../model/lecture-lesson-list-module-list-model';
import LectureLessonListModuleListDTO from '../dto/lecture-lesson-list-module-list-dto';
import dtoSchema from '../schemas/lecture-lesson-list-module-list-schema';
import LectureLessonListPagingResultModel from '../../model/lecture-lesson-list-paging-result-model';
import Int64LookupListResultModel from '../../model/int64-lookup-list-result-model';

export default abstract class LectureLessonListModuleListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LectureLessonListModuleListDTO>) {
    super();
    if (data) {
      this.lessons = data.lessons ? LectureLessonListPagingResultModel.toModel(data.lessons) : undefined;
      this.modules = data.modules ? Int64LookupListResultModel.toModel(data.modules) : undefined;
    }
  }
  /**
  */
  lessons?: LectureLessonListPagingResultModel;
  /**
  */
  modules?: Int64LookupListResultModel;

  static toModel(dto: DeepPartial<LectureLessonListModuleListDTO>): LectureLessonListModuleListModel;
  static toModel(dto: DeepPartial<LectureLessonListModuleListDTO> | undefined | null): LectureLessonListModuleListModel | undefined;
  static toModel(dto: DeepPartial<LectureLessonListModuleListDTO> | undefined | null): LectureLessonListModuleListModel | undefined {
    return dto ? new LectureLessonListModuleListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LectureLessonListModuleListModel> | LectureLessonListModuleListModel): LectureLessonListModuleListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      lessons: unwrapped.lessons,
      modules: unwrapped.modules,
    } as LectureLessonListModuleListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LectureLessonListModuleListModel, can not map to LectureLessonListModuleListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
